import React, { useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
// Providers
import { getUserToken } from '../../../services/login.service';
// Helpers
import { cprRegex } from '../../../helpers/regex';
import { getGlobalCssVariables } from '../../../helpers/general';
import { Button, CprInput, InputError, Popup, PopupButtons, PopupContent } from '../../../components';
import FooterTranslate from '../../../components/layout/Footer/FooterTranslate/FooterTranslate';

interface IAskCprViewProps {
    setDataToPost: (data: any) => void;
}

export const AskCprView = (props: IAskCprViewProps): JSX.Element => {
    const [cpr, setCpr] = useState('');
    const [showCprMatchError, setShowCprMatchError] = useState(false);

    function sendCpr(event: React.FormEvent) {
        event.preventDefault();
        if (cpr === '' || cpr.match(cprRegex ? cprRegex : cprRegex) === null) {
        } else {
            userTokenFlow(cpr);
        }
    }

    function userTokenFlow(cpr: string) {
        const getTokenRequest = {
            cpr: cpr,
        };
        getUserToken(getTokenRequest).then((data) => {
            if (data.userToken !== '') {
                props.setDataToPost(data);
            } else {
                setShowCprMatchError(true);
            }
        });
    }

    function handleCprChanged(event: React.FormEvent) {
        if (showCprMatchError) {
            setShowCprMatchError(false);
        }
        const cprElement = event.target as HTMLInputElement;
        setCpr(cprElement.value);
    }

    return (
        <>
            <Popup show headertext="ASKCPR_ENTER_CPR">
                <form noValidate onSubmit={sendCpr}>
                    <PopupContent className="d-flex flex-column px-3 my-3">
                        <div>
                            <p>
                                <FormattedMessage id="ASKCPR_FIRST_TIME" />
                            </p>
                            <CprInput
                                regex={cprRegex}
                                name="isNgdpMatch"
                                placeholder="ASKCPR_CPRNUMBER"
                                required
                                value={cpr}
                                onChange={handleCprChanged}
                                maxLength={10}
                            />
                            {showCprMatchError && (
                                <InputError>
                                    <FormattedHTMLMessage id="ASKCPR_NO_MATCH_ERROR" tagName="span" />
                                </InputError>
                            )}
                        </div>
                        <p className="mb-2 mt-2">
                            <FormattedHTMLMessage id="ASKCPR_WHY_ASK" />
                        </p>
                        <p className="mb-1">
                            <FormattedHTMLMessage id="ASKCPR_WHY_READ_MORE_LINK" />
                        </p>
                    </PopupContent>
                    <PopupButtons className="pt-2">
                        <FooterTranslate color={getGlobalCssVariables(['--color-white'])[0]} />
                        <Button type="button" onClick={sendCpr} className="mr-2">
                            <FormattedMessage id="OK" defaultMessage="OK" />
                        </Button>
                    </PopupButtons>
                </form>
            </Popup>
        </>
    );
};
